import {inject, injectable} from "inversify";
import {GameSlot} from "@/modules/main-menu/entity";
import {db} from "@/modules/base/services/db";
import {importDataSource} from "@/modules/database/services/db";
import {EventEmitter} from "@/modules/base/events";
import BeforeGameLoadedEvent from "@/modules/main-menu/events/BeforeGameLoadedEvent";
import AfterGameLoadedEvent from "@/modules/main-menu/events/AfterGameLoadedEvent";

@injectable()
export default class GameLoader {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
  ) {}

  public async load(gameSlot: GameSlot) {
    await this.em.emitAsync(new BeforeGameLoadedEvent());

    await importDataSource(db, gameSlot.gameDbDump);

    await this.em.emitAsync(new AfterGameLoadedEvent());
  }
}
